import { render, staticRenderFns } from "./ClientAnswer.component.vue?vue&type=template&id=0cc202ed&scoped=true&"
import script from "./ClientAnswer.component.vue?vue&type=script&lang=js&"
export * from "./ClientAnswer.component.vue?vue&type=script&lang=js&"
import style0 from "./ClientAnswer.component.vue?vue&type=style&index=0&id=0cc202ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc202ed",
  null
  
)

export default component.exports